import { Helmet } from 'react-helmet-async';

const GDPR = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <Helmet>
        <title>GDPR</title>
        <meta name="description" content="Chat with perfect language partner on PairLingo." />
        <meta name="keywords" content="language learning, pairlingo, chat, match, speaking chat, german language partner chat" />
      </Helmet>
      <h2 className="text-2xl font-bold mb-4">GDPR Compliance</h2>
      <p className="text-gray-700">We comply with GDPR regulations by ensuring:</p>
      <ul className="list-disc ml-6">
        <li>Transparent data collection practices</li>
        <li>User consent for data processing</li>
        <li>Right to data deletion upon request</li>
        <li>Secure storage of personal information</li>
      </ul>
      <p className="mt-2">If you have any questions, feel free to contact us at support@pairlingo.com.</p>
    </div>
  );
};

export default GDPR;
